export default "__VITE_ASSET__2c3a0d92__"